export default "__VITE_ASSET__DO7l9JIk__"